import { Link } from "react-router-dom";
import { site } from "@/config/site";
import { images } from "@/config/images";

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* 会社情報 */}
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src={images.logo}
                alt={`${site.companyName} ロゴ`}
                className="h-9 w-auto object-contain"
              />
              <span className="font-heading font-bold text-foreground-950">
                {site.companyName}
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              猟師さんが捕獲した猪。どうにか循環させたいと思い会社をつくりました。
              女猟師が止め刺し・血抜き・精肉まで一人で行い、命を無駄なく循環させています。
            </p>
          </div>

          {/* メニュー */}
          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">
              <a href="#top" className="hover:text-primary-700 transition-colors">メニュー</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/products" className="text-foreground-600 hover:text-primary-700 transition-colors">商品・サービス</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-700 transition-colors">株式会社MEGURIについて</Link></li>
              <li><Link to="/leather" className="text-foreground-600 hover:text-primary-700 transition-colors">猪革・レザー紹介</Link></li>
              <li><Link to="/purchase" className="text-foreground-600 hover:text-primary-700 transition-colors">購入ページ</Link></li>
              <li><Link to="/contact" className="text-foreground-600 hover:text-primary-700 transition-colors">お問い合わせ</Link></li>
              <li><Link to="/access" className="text-foreground-600 hover:text-primary-700 transition-colors">アクセス</Link></li>
            </ul>
          </div>

          {/* 基本情報 */}
          <div>
            <h4 className="text-sm font-bold text-foreground-950 mb-4">
              <a href="#top" className="hover:text-primary-700 transition-colors">会社情報</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-map-pin-line text-primary-600 mt-0.5"></i>
                <span>{site.address}</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-phone-line text-primary-600 mt-0.5"></i>
                <a href={`tel:${site.phone}`} className="hover:text-primary-700 transition-colors">{site.phone}</a>
              </li>
              <li className="flex gap-2">
                <i className="ri-mail-line text-primary-600 mt-0.5"></i>
                <a href={`mailto:${site.email}`} className="hover:text-primary-700 transition-colors break-all">{site.email}</a>
              </li>
              <li className="flex gap-2">
                <i className="ri-time-line text-primary-600 mt-0.5"></i>
                <span>定休日：{site.holiday}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 法的リンク */}
        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
            <Link to="/legal" className="hover:text-primary-700 transition-colors">特定商取引法に基づく表記</Link>
            <Link to="/privacy" className="hover:text-primary-700 transition-colors">プライバシーポリシー</Link>
          </div>
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {site.companyName} All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}